import ProgramUtils from 'core-system/Program/ProgramUtils'
import TransitLogo from 'core-system/TransitLogo'
import React from 'react'
import { Merchant, ServiceModeType } from 'redux/programs/programsTypes'
import ScrollerElement from './ScrollerElement'

const getProviders = (
  merchantIds: string[],
  merchantsMap: Dictionary<Merchant>,
  customData?: Dictionary,
  sortByPartner?: boolean,
  showSubtitle: boolean = true
) => {
  return [...merchantIds]
    .sort((a, b) => {
      if (sortByPartner) {
        const firstProvider = merchantsMap[a]?.fleetPartner ? 1 : 0
        const secondProvider = merchantsMap[b]?.fleetPartner ? 1 : 0

        if (firstProvider < secondProvider) return 1
        if (firstProvider > secondProvider) return -1
      } else if (customData) {
        if (customData[a].spend < customData[b].spend) return 1
        if (customData[a].spend > customData[b].spend) return -1
        if (customData[a].trips < customData[b].trips) return 1
        if (customData[a].trips > customData[b].trips) return -1
      }
      return 0
    })
    .map((merchantId, idx) => {
      const merchant = merchantsMap[merchantId]
      if (!merchant || merchant.modeTypes.length === 0) {
        return null
      }
      const modeTypes = merchant.modeTypes
        .map((modeType) =>
          ProgramUtils.formatElectricModeTypes(
            modeType || 'unknown'
          ).toLowerCase()
        )
        .join(', ')

      return (
        <ScrollerElement
          logoElement={
            <TransitLogo
              modeType={
                merchant.iconUrl
                  ? 'custom'
                  : (merchant.modeTypes[0] as ServiceModeType)
              }
              src={merchant.iconUrl || merchant.modeTypes[0]}
              size='small'
            />
          }
          name={merchant.name}
          subtitle={showSubtitle ? modeTypes : undefined}
        />
      )
    })
}

export default {
  getProviders,
}
